module.exports = __webpack_public_path__ + "resources/img/img_dvision6.37f1c0ea8396df388e7c79db7db7b157.png";